import type { ReactNode } from 'react';

type CtaBandProps = {
  title: string;
  description: string;
  action: ReactNode;
};

export function CtaBand({ title, description, action }: CtaBandProps) {
  return (
    <section className="cta-band">
      <div className="cta-inner">
        <div>
          <p className="eyebrow">Demo-ready</p>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <a className="button button-primary" href="mailto:info@beyond4.com?subject=B4%20platform%20walkthrough">
          {action}
        </a>
      </div>
    </section>
  );
}
